._searchWrapper_87vy9_1 {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

._searchIcon_87vy9_8 {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--muted-foreground);
  height: 16px;
  width: 16px;
  z-index: 1;
}

._searchInput_87vy9_19 {
  width: 100% !important;
  padding-left: 36px;
  padding-right: 28px;
  border: none;
  box-shadow: none;
  font-size: 14px;
  background-color: transparent;
  height: 36px;
}
._searchInput_87vy9_19:hover, ._searchInput_87vy9_19:focus {
  border: 0;
  box-shadow: none;
  background: transparent !important;
}

._clearButton_87vy9_35 {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  color: var(--muted-foreground);
  cursor: pointer;
  padding: 2px 6px;
  font-size: 16px;
  line-height: 1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
._clearButton_87vy9_35:hover {
  color: var(--foreground);
}